import { ConfirmModal } from "features/common/components/ConfirmModal";
import { useReconciliationModal } from "./useReconciliationModal";

export interface ReconciliationModalProps {
  title: string;
  open: boolean;
  onClose: () => void;
  type: "INTERNAL" | "EXTERNAL";
}

export const ReconciliationModal = ({
  title,
  open,
  onClose,
  type,
}: ReconciliationModalProps) => {
  const {
    isExecutingRec,
    handleStartRec,
    handleClose,
    reconciliationIsAllowed,
    reconciliationError,
    severityMessage,
  } = useReconciliationModal({
    reportType: {
      type: "RECONCILIATION",
      action: type,
    },
    onClose,
  });

  return (
    <ConfirmModal
      title={title}
      open={open}
      onClose={handleClose}
      disableBackdropClick
      isLoading={isExecutingRec}
      error={reconciliationError}
      onConfirm={handleStartRec}
      children={"Do you want to START the reconciliation ?"}
      disableConfirmButton={!reconciliationIsAllowed}
      severityMessage={severityMessage}
    />
  );
};
